import { useState } from "react";
import Input from "shared/Input/Input";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import useFetch from "./useFetch";
import Skeleton from "@mui/material/Skeleton";
//
const ProductSearchBar = () => {
  //--------------------------//
  //-------------------------//
  const { data, loading, err }: any = useFetch();
  const [search, setSearch] = useState<any>("");
  const [recentSearch, setRecentSearch] = useState(false);
  //---------------------------------------------//
  //------------------------//
  //
  //
  const history = useHistory();
  //
  //
  const handleSubmit = (e: any) => {
    e.preventDefault();
    history.push(`/search-implements/${search}`);
  };
  //
  const makeSearch = (e: any) => {
    setSearch(e.target.value);
  };
  ////////
  const onFocus = () => {
    setRecentSearch(true);
  };

  const onBlur = () => {
    //
    //
    setTimeout(() => {
      setRecentSearch(false);
    }, 150);
    //
    ////////////////////////
    //
  };

  return (
    <>
      <form
        className="relative w-full"
        method="POST"
        autoComplete="off"
        onSubmit={handleSubmit}
      >
        <label
          htmlFor="search-input"
          className="text-neutral-500 dark:text-neutral-300"
        >
          <span className="sr-only">Search all icons</span>
          <div className="relative w-98">
            <Input
              required={true}
              className="w-full bg-[#F0F0F0] h-11  border-0 text-[16px]"
              name="searchnewproducts"
              type="search"
              onChange={makeSearch}
              onFocus={onFocus}
              onBlur={onBlur}
              value={search}
              placeholder="Find machinery by name, brand, category etc."
              sizeClass="pt-4 pb-4 pr-10"
              rounded="rounded-md"
            />

            {recentSearch && (
              <div className="recent-searches absolute w-full bg-[#fffcfc] p-3 rounded-md overflow-y-scroll md:h-64">
                <h2 className="text-slate text-[15px] font-medium p-1">
                  Recent Searches
                </h2>{" "}
                <ul>
                  {data?.recentSearches?.length > 0 ? (
                    <>
                      {" "}
                      {data.recentSearches.map((item: any, index: number) => (
                        <li
                          key={item.label}
                          className="p-1 ml-2 text-[14px] font-medium text-black"
                        >
                          <Link to={item.path}>{item.label}</Link>
                        </li>
                      ))}
                    </>
                  ) : (
                    <li>
                      <Skeleton animation="wave" />
                      <Skeleton animation="wave" />
                      <Skeleton animation="wave" />
                      <Skeleton animation="wave" />
                    </li>
                  )}
                </ul>
                <h2 className="text-slate text-[15px] font-medium p-1">
                  Popular Searches
                </h2>
                <ul>
                  {data?.popularSearches?.length > 0 ? (
                    <>
                      {" "}
                      {data.popularSearches.map((item: any, index: number) => (
                        <li
                          key={index}
                          className="p-1 ml-2 text-[14px] font-medium text-black"
                        >
                          <Link to={item.path}>{item.label}</Link>
                        </li>
                      ))}
                    </>
                  ) : (
                    <li>
                      <Skeleton animation="wave" />
                      <Skeleton animation="wave" />
                      <Skeleton animation="wave" />
                      <Skeleton animation="wave" />
                    </li>
                  )}
                </ul>
              </div>
            )}
          </div>

          <button
            className="absolute right-0 h-full w-10 rounded-r-md top-1/2 transform -translate-y-1/2 bg-[#1550A1]"
            type="submit"
          >
            <i className="las la-search text-lg text-white"></i>
          </button>
        </label>
      </form>
    </>
  );
};

export default ProductSearchBar;
